import $ from 'jquery';

$.onAuth(({ website }) => {
  const $D = $(document);

  $D.on('websocket:heartbeat', (evt, now) => {
    window.now = now;

    $('.item-countdown').each((idx, obj) => {
      const $obj = $(obj).removeClass('text-strong text-warning text-danger invisible');
      const dt = Math.max(0, Math.floor($obj.data('end') - now));

      if (isNaN(dt)) $obj.find('span').text('');
      else if (dt === 0) $obj.addClass('text-strong text-danger').find('span').text('UPDATING');
      else {
        const v = [];
        let s = dt;
        let d = 0;
        let h = 0;
        let m = 0;

        if (s > 0) {
          d = Math.floor(s / 86400);
          s -= d * 86400;
          if (d >= 1) v.push(`${d} day${d === 1 ? '' : 's'}`);

          h = Math.floor(s / 3600);
          s -= h * 3600;
          if (h >= 1) v.push(`${h} hour${h === 1 ? '' : 's'}`);

          m = Math.floor(s / 60);
          s -= m * 60;
          if (m >= 1 && d < 1) v.push(`${m} minute${m === 1 ? '' : 's'}`);
        }

        if (h < 1 && d < 1) v.push(`${s} second${s === 1 ? '' : 's'}`);

        if (dt < 3600) $obj.addClass('text-strong');
        if (dt < 60) $obj.addClass(dt <= 10 ? ' text-danger' : ' text-warning');

        $obj.find('span').text(v.join(' '));
      }
    });
  });

  $D.on('websocket:closed', () => {
    $('.item-countdown').removeClass('text-warning invisible').addClass('text-strong text-danger').find('span').text('RECONNECTING');
  });
});
